module.exports = __webpack_public_path__ + "media/packs/images/partners/partner4-6d961cebcb56ac36d9f6cdbbc2c1f0e1.jpg";